import { Injectable, inject } from '@angular/core';
import { ConfigurationService } from '@pflegix/config';
import { HttpClientService } from '@pflegix/http-client';
import { OrderPopulatedResponseDto, UpdateOrderDto } from '@pflegix/types';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OrderUpdateApi {
  private readonly config = inject(ConfigurationService);
  private readonly httpClient = inject(HttpClientService);

  public update(id: string, dto: UpdateOrderDto): Observable<OrderPopulatedResponseDto> {
    return this.httpClient.patch<OrderPopulatedResponseDto>(`${this.apiUrl}/${id}`, dto);
  }

  private get apiUrl(): string {
    return `${this.config.get('basePflegixApiUrl')}/api/v2/orders`;
  }
}
